import React from 'react';
import { func, string } from 'prop-types';
import styles from './styles/styles.module.scss';
import IconClose12 from '../../../../../../../components/svg/shared/IconClose12';

const ExitCircle = ({ onClick, className }) => {
  return (
    <button type="button" className={`${styles.container} ${className}`} onClick={onClick}>
      <IconClose12 />
    </button>
  );
};

ExitCircle.propTypes = {
  onClick: func,
  className: string
};

ExitCircle.defaultProps = {
  onClick: () => {},
  className: ''
};

export default ExitCircle;
